<script setup lang="ts">
import { PropType } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

type Office = {
  id: number;
  name: string;
  address: string;
};

const props = defineProps({
  office: {
    type: Object as PropType<Office>,
    required: true
  }
});

function getSearchByOfficeRoute(officeId: number) {
  return {
    name: "SearchByOffice",
    params: {
      officeId
    }
  };
}
</script>
<template>
  <div class="office-card bg-white border-outline-color border">
    <RouterLink :to="getSearchByOfficeRoute(office.id)">
      <div class="office-content">
        <div class="office-info">
          <p class="office-name" data-testid="office-name">
            {{ office.name }}
          </p>
          <div class="d-flex align-items-center">
            <FeatherIcon icon="map-pin" size="14" class="mr-1 text-mild" />
            <p class="office-address" data-testid="office-address">
              {{ office.address }}
            </p>
          </div>
        </div>
        <div class="ml-auto">
          <slot />
        </div>
      </div>
    </RouterLink>
  </div>
</template>
<style lang="scss" scoped>
.office-card {
  padding: 16px 12px;
  border-radius: 4px;
  transition: padding 0.4s 0.4s, margin 0.4s 0.4s, opacity 0.3s;
}

.office-content {
  display: flex;
  flex-direction: column;
  gap: 6px;

  .office-info {
    display: flex;
    flex-direction: column;
    gap: 2px;

    .office-name {
      font-size: 18px;
      font-weight: 500;
      line-height: 23px;
    }

    .office-address {
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      color: $mild;
    }
  }
}
</style>
